<template>
  <div class="export-field">
    <div class="status-box">
      <a href="javascript:void(0);" class="status-button" @click="showConfirmationModal">
        Update Excel Password
      </a>
    </div>

    <!-- Password Modal -->
    <div class="modal__wrapper" v-if="showPasswordField">
      <div class="modal__screen" @click.prevent="closeConfirmationModal"></div>
      <div class="modal">
        <div class="modal__header">
          <a href="#" class="modal__close" @click.prevent="closeConfirmationModal">
            <i class="fa fa-times"></i>
          </a>
        </div>
        <div class="modal__body">
          <p>Please write current excel password</p>
          <input type="password" v-model="enteredPassword" placeholder="Current Password">
          <input type="password" v-model="newPassword" placeholder="New Password">
          <input type="password" v-model="confirmNewPassword" placeholder="Confirm New Password">
          <p>
            <button class="button button-primary--small" @click.prevent="validatePassword">Submit Password</button>
            <button class="button button-secondary--small" @click.prevent="closeConfirmationModal">Cancel</button>
          </p>
          <p v-if="modalMessage" :style="{ color: isError ? 'red' : 'green' }">{{ modalMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      showPasswordField: false,
      enteredPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      modalMessage: '',
      isError: false,
      validPassword: 'pT8#xA!w9Qz@4uLs'
    };
  },
  methods: {
    showConfirmationModal() {
      this.enteredPassword = '';
      this.newPassword = '';
      this.confirmNewPassword = '';
      this.modalMessage = '';
      this.isError = false;
      this.showPasswordField = true;
    },

    closeConfirmationModal() {
      this.showPasswordField = false;
      this.enteredPassword = '';
      this.newPassword = '';
      this.confirmNewPassword = '';
      this.modalMessage = '';
      this.isError = false;
    },

    validatePassword() {
      if (this.newPassword !== this.confirmNewPassword) {
        this.isError = true;
        this.modalMessage = 'Password and confirmation fields do not match';
        return;
      }
      axios
        .get('/api/v1/excel-password/update', {
          params: {
            oldPassword: this.enteredPassword,
            newPassword: this.newPassword,
          },
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
          },
        })
        .then(response => {
          console.log('Response:', response.data);

          this.modalMessage = response.data.message;
          this.isError = !response.data.success;

          if (response.data.success) {
            setTimeout(() => this.closeConfirmationModal(), 3000);
          } else {
            setTimeout(() => { this.modalMessage = ''; }, 3000);
          }
        })
        .catch(error => {
          console.error('Error:', error);

          this.modalMessage =
            error.response.data.message ||
            error.message ||
            'An unexpected server error occurred.';

          this.isError = true;
          setTimeout(() => { this.modalMessage = ''; }, 3000);
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/UpdateExcelPassword.vue